import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: './accessibility-notice-page.component.html',
    styleUrls: ['./accessibility-notice-page.component.scss']
})
export class AccessibilityNoticePageComponent implements OnInit {
    ngOnInit(): void {
        window.scrollTo({ top: 0 });
    }
}
